import React, { useContext, useMemo } from 'react';
import { CnCard } from '@/components/cn-card';
import { CnEllipsis } from '@/components/cn-ellipsis';
import { CardItemsStateCtx } from '../../context/card-items';
import { ItemFormat } from '../item-format';
/** 卡片渲染 */
export const ItemCard = (props) => {
    const { icon, title, desc, action, subIcon, subTitle, subDesc, subAction, tags, primaryKey, showSelect, selectedKeys, setSelectedKeys, } = useContext(CardItemsStateCtx);
    const { columns } = useContext(CardItemsStateCtx);
    const { rowIndex, data, onClick } = props;
    const primaryValue = data[primaryKey];
    const footAction = useMemo(() => {
        const temp = { ...props.footAction };
        if (showSelect && primaryKey) {
            temp.checkBox = {
                checked: selectedKeys.has(primaryValue),
                onChange: (checked) => {
                    if (checked) {
                        setSelectedKeys((prev) => {
                            const val = new Set(prev);
                            val.add(primaryValue);
                            return val;
                        });
                        return;
                    }
                    setSelectedKeys((prev) => {
                        const val = new Set(prev);
                        val.delete(primaryValue);
                        return val;
                    });
                },
            };
        }
        return temp;
    }, [
        props.footAction,
        showSelect,
        primaryKey,
        selectedKeys,
        setSelectedKeys,
        primaryValue,
    ]);
    return (React.createElement(CnCard, { className: "cn-ui-m-card-items-card", icon: icon ? icon(data) : undefined, title: title ? title(data) : undefined, desc: desc ? desc(data) : undefined, action: action ? action(data) : undefined, subIcon: subIcon ? subIcon(data) : undefined, subTitle: subTitle ? subTitle(data) : undefined, subDesc: subDesc ? subDesc(data) : undefined, subAction: subAction ? subAction(data) : undefined, tags: tags ? tags(data) : [], footAction: footAction },
        React.createElement("div", { onClick: onClick }, columns.slice(0, 6).map((column, index) => {
            const { dataIndex } = column;
            const value = dataIndex ? String(data[dataIndex]) : undefined;
            return (React.createElement("div", { className: "cn-ui-m-card-items-card-row", key: value || index },
                React.createElement(CnEllipsis, { className: "cn-ui-m-card-items-card-row-label" }, column.title || dataIndex),
                React.createElement("div", { className: "cn-ui-m-card-items-card-row-value" },
                    React.createElement(ItemFormat, { mode: "simple", rowIndex: rowIndex, data: data, column: column }))));
        }))));
};
